import { ActionKeys } from '~/actions/constants';
import * as parcelTemplateActions from '~/actions/parcel-template.actions';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getCarrierParcelTemplates, getParcelTemplates } from '~/services/parcel-template.service';
import { normalizeCarrierName } from '~/types/Carrier';
import CarrierParcelTemplate, * as carrierParcelTemplate from '~/types/CarrierParcelTemplate';
import ParcelTemplate, * as parcelTemplate from '~/types/ParcelTemplate';

export function* fetchParcelTemplates() {
  try {
    const response = yield call(getParcelTemplates);
    const parcelTemplates: ParcelTemplate[] = response.data.results.map((jsonParcelTemplate) =>
      parcelTemplate.fromJSON(jsonParcelTemplate),
    );
    const payload = { parcelTemplates };
    yield put(parcelTemplateActions.fetchParcelTemplatesSuccess(payload));
  } catch (err) {
    yield put(parcelTemplateActions.fetchParcelTemplateError());
  }
}

export function* fetchCarrierParcelTemplates() {
  try {
    const response = yield call(getCarrierParcelTemplates);
    const carrierParcelTemplates: CarrierParcelTemplate[] = response.data.results.map(
      (jsonCarrierParcelTemplate) => carrierParcelTemplate.fromJSON(jsonCarrierParcelTemplate),
    );

    const carrierParcelTemplatesByCarrier = carrierParcelTemplates.reduce(
      (hash, parcelTemplate: CarrierParcelTemplate) => {
        return {
          ...hash,
          [normalizeCarrierName(parcelTemplate.provider)]: [
            ...(hash[normalizeCarrierName(parcelTemplate.provider)] || []),
            parcelTemplate,
          ],
        };
      },
      {},
    );

    const payload = {
      carrierParcelTemplates: carrierParcelTemplatesByCarrier,
    };
    yield put(parcelTemplateActions.fetchCarrierParcelTemplatesSuccess(payload));
  } catch (err) {
    yield put(parcelTemplateActions.fetchCarrierParcelTemplateError());
  }
}

export default [
  takeLatest(ActionKeys.PARCEL_TEMPLATE_FETCH, fetchParcelTemplates),
  takeLatest(ActionKeys.CARRIER_PARCEL_TEMPLATE_FETCH, fetchCarrierParcelTemplates),
];
